import { useEffect } from 'react'

function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      const el = ref?.current
      if (!el || el.contains(event.target)) {
        return
      }

      if (event.target.classList.contains('profile-element')) return
      handler(event)
    }

    document.addEventListener(`mousedown`, listener)

    return () => {
      document.removeEventListener(`mousedown`, listener)
    }
  }, [ref, handler])
}

export default useOnClickOutside
